import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';
import { Account } from '@/features/accounts/types';
import AccountCell from './cells/AccountCell';

const columnHelper = createColumnHelper<Account>();

export const columns: ColumnDef<Account>[] = [
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <FormattedMessage id="accounts.table.account" defaultMessage="Account" />,
    cell: ({ row }) => <AccountCell account={row.original} />,
    enableSorting: true,
  }),

  columnHelper.display({
    id: 'status',
    header: () => <FormattedMessage id="accounts.table.status" defaultMessage="Status" />,
  }),

  columnHelper.display({
    id: 'dateRange',
    header: () => <FormattedMessage id="accounts.table.dateRange" defaultMessage="Date Range" />,
  }),

  columnHelper.display({
    id: 'currentAppointment',
    header: () => <FormattedMessage id="accounts.table.currentAppointment" defaultMessage="Current Appointment" />,
  }),

  columnHelper.display({
    id: 'actions',
    header: () => <FormattedMessage id="accounts.table.actions" defaultMessage="Actions" />,
    size: 1,
  }),

  columnHelper.display({
    id: 'delete',
    header: () => null,
    size: 40,
  }),
];
